module.exports = __webpack_public_path__ + "media/images/teams/logo__6-b53754cd33aba124e84851aa1b75f926.svg";